import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import logo from "./logo-menu-brand@2x.png";
import CloseIcon from "@material-ui/icons/Close";

import Grid from "@material-ui/core/Grid";
import Slide from "@material-ui/core/Slide";
import NavigationPanel from "./NavigationPanel";
import { Box } from "@material-ui/core";

const drawerWidth = 250;

const useStyles = makeStyles(theme => ({
  drawer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },

  drawerPaper: {
    width: drawerWidth,
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
    boxShadow: "5px 0 10px rgba(0, 0, 0, 0.15)",
    overflow: "hidden",
  },

  closeTab: {
    position: "fixed",
    left: drawerWidth - 5,
    top: theme.spacing(6),
    zIndex: 1200,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.contrastText,
    color: theme.palette.primary.main,
    width: 60,
    height: 55,
    borderBottomRightRadius: 50,
    borderTopRightRadius: 50,
  },

  drawerLogo: {
    position: "fixed",
    height: 135,
    width: drawerWidth,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.15)",
  },

  image: {
    width: 60,
    height: 60,
  },

  close: {
    cursor: "pointer",
    fontSize: "3rem",
  },

  support: {
    width: drawerWidth,
    textAlign: "center",
    margin: theme.spacing(6, 0),
  },

  supportLink: {
    color: theme.palette.primary.main,
    textTransform: "uppercase",
    fontWeight: "normal",
    fontSize: "1.4rem",
    lineHeight: "1.8rem",
  },
}));

const NavigationDrawer = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <Box>
      <Slide direction={"right"} in={open}>
        <div className={classes.closeTab}>
          <CloseIcon
            classes={{
              root: classes.close,
            }}
            onClick={onClose}
            style={{
              fontSize: "3rem",
            }}
          />
        </div>
      </Slide>

      <Drawer
        className={classes.drawer}
        variant="persistent"
        open={open}
        anchor="left"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerLogo}>
          <img className={classes.image} src={logo} alt="BiblioBoard" />
        </div>

        <NavigationPanel onClose={onClose} />

        <Grid container item xs direction="column" justify="flex-end">
          <div className={classes.support}>
            <a
              className={classes.supportLink}
              href="mailto:support@biblioboard.com"
            >
              Support
            </a>
          </div>
        </Grid>
      </Drawer>
    </Box>
  );
};

export default NavigationDrawer;
